import { type ReactElement } from 'react'
import { ActionIcon } from '@mantine/core'
import { useOpenUniversalSearch } from '@hooks'
import { SizePrimitives, useTranslation } from '@front/model'
import { MaterialSymbolIcon } from '../terros/icon/MaterialSymbolIcon'

const HEADER_SEARCH_TARGET = SizePrimitives['11']

type MobileHeaderSearchButtonProps = {
  onBeforeOpen?: VoidFunction
}

export const MobileHeaderSearchButton = ({ onBeforeOpen }: MobileHeaderSearchButtonProps): ReactElement => {
  const { t } = useTranslation()
  const openSearch = useOpenUniversalSearch()

  const openFromHeader = (): void => {
    onBeforeOpen?.()
    openSearch()
  }

  return (
    <ActionIcon
      aria-label={t('Search')}
      color='white'
      h={HEADER_SEARCH_TARGET}
      hiddenFrom='xs'
      radius='md'
      size={HEADER_SEARCH_TARGET}
      variant='subtle'
      w={HEADER_SEARCH_TARGET}
      onClick={openFromHeader}
    >
      <MaterialSymbolIcon icon='search' size='lg' />
    </ActionIcon>
  )
}
